module.exports = __webpack_public_path__ + "img/pencil.5aef202b.svg";